import { render, staticRenderFns } from "./CertificatMedicalVisit.vue?vue&type=template&id=755eef2b&scoped=true&"
import script from "./CertificatMedicalVisit.vue?vue&type=script&lang=js&"
export * from "./CertificatMedicalVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755eef2b",
  null
  
)

export default component.exports